import React from 'react';

interface PhysicalCardProps {
  index: number;
  pattern: string[][];
  title: string;
  writeText: string;
}

/**
 * Physical Hitster Bingo Card - exactly 110mm × 165mm with 5×5 colored grid
 */
const PhysicalBingoCard: React.FC<PhysicalCardProps> = ({ 
  index, 
  pattern, 
  title, 
  writeText 
}) => {
  return (
    <section className="card">
      {/* 5×5 Grid (100mm × 100mm total) */}
      <div className="grid">
        {pattern.flat().map((colorClass, cellIdx) => (
          <div key={cellIdx} className={`cell ${colorClass}`} />
        ))}
      </div>

      {/* Black title band (15mm) with pink "HITSTER" text */}
      <div className="title-band">
        <div className="title-text">{title}</div>
      </div>

      {/* White writeable area (41mm × 92mm) */}
      <div className="write-area-wrap">
        <div className="write-area">{writeText}</div>
      </div>
    </section>
  );
};

export default PhysicalBingoCard;
